import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const SummaryApi = createApi({
  reducerPath: "Summary",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_URL}/reports`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      headers.set("Accept", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getVehicleTripsSum: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        page: currentpage,
        pageSize: limit,
      }) =>
        `/tracking?from=${startdate}&to=${enddate}&deviceId=${ids}&page=${currentpage}&pageSize=${limit}`,
    }),
    getVehicleRoutes: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        page: currentpage,
        pageSize: limit,
      }) =>
        `/route?from=${startdate}&to=${enddate}&deviceId=${ids}&page=${currentpage}&pageSize=${limit}`,
    }),
    getSpeedReport: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        selectedgroups: groupid,
      }) =>
        `/speed?from=${startdate}&to=${enddate}${
          ids ? `&deviceId=${ids}` : ""
        }${groupid ? `&${groupid}` : ""}`,
    }),
    getEventReport: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: id,
        eventtype: type,
      }) => `/events?deviceId=${id}&from=${startdate}&to=${enddate}&${type}`,
    }),
    getAlarmReport: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: id,
        eventtype: type,
      }) => `/events?${id}&from=${startdate}&to=${enddate}&type=${type}`,
    }),

    getStopReportSum: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        page: currentpage,
        pageSize: limit,
      }) =>
        `/stop?from=${startdate}&to=${enddate}&deviceId=${ids}&page=${currentpage}&pageSize=${limit}`,
    }),

    getDistanceReport: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        page: currentpage,
        pageSize: limit,
      }) =>
        `/distance?from=${startdate}&to=${enddate}&deviceId=${ids}&page=${currentpage}&pageSize=${limit}`,
    }),
    getFuelReport: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        page: currentpage,
        pageSize: limit,
      }) =>
        `/fuel?from=${startdate}&to=${enddate}&deviceId=${ids}&page=${currentpage}&pageSize=${limit}`,
    }),
    getOdometerReport: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        selectedids: ids,
        page: currentpage,
        pageSize: limit,
      }) =>
        `/odometer?from=${startdate}&to=${enddate}&deviceId=${ids}&page=${currentpage}&pageSize=${limit}`,
    }),
  }),
});

export const {
  //   useGetVehicleTripsQuery,
  useLazyGetVehicleTripsSumQuery,
  useGetVehicleRoutesQuery,
  useGetSpeedReportQuery,
  useLazyGetSpeedReportQuery,
  useGetEventReportQuery,
  useGetAlarmReportQuery,
  //   useGetStopReportQuery,
  useLazyGetStopReportSumQuery,
  useGetDistanceReportQuery,
  useLazyGetDistanceReportQuery,
  useGetFuelReportQuery,
  useLazyGetFuelReportQuery,
  useGetOdometerReportQuery,
  useLazyGetOdometerReportQuery,
} = SummaryApi;
